import React, { Fragment } from 'react';
import Link from 'react-router-dom/Link';
import { toastr } from '../../common/cores';
import TitleBox from '../../components/common/TitleBox';
import SlotRight from '../../components/Slot/SlotRight';

const minigames = [
    {
        to: "/minigame/eospowerball",
        image: "../images/minigame/ntry_eos.png",
        name: "EOS파워볼",
        notReady: false,
    },
    // {
    //     to: "/minigame/highlow",
    //     image: "../images/minigame/ntry_powerladder.png",
    //     name: "토큰하이로우",
    //     notReady: true,
    // },
    // {
    //     to: "/minigame/roulette",
    //     image: "../images/minigame/ntry_speedkeno.png",
    //     name: "토큰룰렛",
    //     notReady: true,
    // },
    {
        to: "/minigame/powerball_evo",
        image: "../images/minigame/powerball_evo.png",
        name: "에볼루션파워볼",
        notReady: false,
    },
    {
        to: "/minigame/nuguri",
        image: "../images/minigame/nuguri.png",
        name: "고픽 너구리",
        notReady: false,
    },
    {
        to: "/minigame/soccer",
        image: "../images/minigame/soccer.png",
        name: "고픽 축구",
        notReady: false,
    },
    {
        to: "/minigame/baseball",
        image: "../images/minigame/baseball.png",
        name: "고픽 야구",
        notReady: false,
    },
    {
        to: "/minigame/squidgame",
        image: "../images/minigame/squidgame.png",
        name: "고픽 오징어게임",
        notReady: false,
    },
]

const Minigame = () => {
    const onList = (notReady) => {
        if(notReady) return toastr.warning("준비즁입니다.");
    }
    return (
        <Fragment>
            <TitleBox title="미니게임"/>
            <div className="contents_wrap">
                <div className="contents_box">
                    <div className="game_list mini_list slot_list">
                        <ul className="flex-wrap justify-content-center" style={{width: "100%"}}>
                            {
                                minigames.map((list, index) => {
                                    return (
                                            <li style={{width: "33.333%", padding:"5px", minWidth:"350px"}} key={index}>
                                                <Link to={list.to} className="game" onClick={ (e => { if(list.notReady) { e.preventDefault(); toastr.info('점검중입니다.'); }})}>
                                                    <img src={list.image} style={{ width: "100%" }} alt="" />
                                                    {/* <span className="gameName">{list.name}</span> */}
                                                </Link>
                                            </li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default Minigame;


// WEBPACK FOOTER //
// ./src/containers/minigame/MiniGame.js